import styled from "styled-components";

export default styled.div`
.rich-text {
    min-width: 200px;
    max-width: 800px;
}
`;
